<template>
<div>
  <v-card-title>
    <v-flex xs11>
      <v-text-field required v-model="editModel.name"></v-text-field>
    </v-flex>

    <v-flex xs1>
      <v-icon @click='$emit("close", {})' small fab block color="green darken-2" style="color: #efefef;">edit</v-icon>
    </v-flex>
  </v-card-title>
  <v-divider></v-divider>
  <v-list dens>
    <v-list-tile>
      <v-list-tile-content>{{$t('related.code')}}</v-list-tile-content>
      <v-list-tile-content class="align-end">
        <v-text-field style="margin-left:2rem;" required v-model="editModel.code"></v-text-field>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-for="(keyObj,index) in relatedSchema.keys" :key="index">
      <v-list-tile-content>{{ keyObj.name }}:</v-list-tile-content>
      <v-list-tile-content width="30%" style="margin-top:-1rem;" class="align-end">
        <v-text-field required v-model="editModel.values[index].value"></v-text-field>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-divider></v-divider>
  <v-card-actions class="justify-center">
    <v-btn flat @click="$emit('update', editModel)" color="green">{{$t('base.save')}}</v-btn>
  </v-card-actions>
</div>
</template>
<script>

export default {
  props: ['deleteEnabled', 'relatedValue', 'relatedSchema'],
  data() {
    return {
      edit: false,
      editModel: {}
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
    let model = {...this.relatedValue}

    for (let keyOfKeys in this.relatedSchema.keys) {
      let keyObj = this.relatedSchema.keys[keyOfKeys]
      if (model.values.find(el => el.order == keyObj.order)) {
        continue
      }

      model.values.push({order: keyObj.order, value: ""})
    }

    model.values = model.values.sort((a, b) => a.order > b.order)
    this.editModel = model
  }
}
</script>

<style>
</style>
